import { render, staticRenderFns } from "./ResourceAclDeleteModal.vue?vue&type=template&id=0ba6a6d9&"
import script from "./ResourceAclDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ResourceAclDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports